<template>
	<div class="mt-4">
		<label :class="label_class" style="width: fit-content; padding-top: 1rem; float: inline-start;">

			<div
				id="customInput_file_cloude"
				class="form-Control pointer text-success border-0"
				:class="textClass"
				@click="show = true"
				style="text-decoration: underline; background: none;"
			>
			<img
			width="25"
			:src="require('../../assets/img/upload.svg')"
			:alt="label"
			/>
			<span id="customInput_file_cloude_span" >
				{{ (value=='' || value==null)? label : value }}
			</span>
			<span v-if="error">
				( {{error_text}} )
			</span>
			</div>
			<input
				type="file"
				id="files"
				class="d-none"
				:accept="accept"
				name="files"
				
				@change="uploadImages"
				v-if="inputCheck"
			/>
			{{ label_sm }}
		</label>
		<button v-if="leading" type="button" class="btn btn-secondary " style="background: none;border: none;" data-toggle="tooltip" data-html="true" :title="leading">
			<svg style="width: 18px;height: 18px;" fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="800px" height="800px" viewBox="0 0 416.979 416.979" xml:space="preserve"> <g> <path d="M356.004,61.156c-81.37-81.47-213.377-81.551-294.848-0.182c-81.47,81.371-81.552,213.379-0.181,294.85 c81.369,81.47,213.378,81.551,294.849,0.181C437.293,274.636,437.375,142.626,356.004,61.156z M208.554,334.794 c-11.028,0-19.968-8.939-19.968-19.968s8.939-19.969,19.968-19.969c11.028,0,19.968,8.939,19.968,19.969 C228.521,325.854,219.582,334.794,208.554,334.794z M241.018,214.566c-11.406,6.668-12.381,14.871-12.43,38.508 c-0.003,1.563-0.008,3.14-0.017,4.726c-0.071,11.172-9.147,20.18-20.304,20.18c-0.044,0-0.088,0-0.131,0 c-11.215-0.071-20.248-9.22-20.178-20.436c0.01-1.528,0.013-3.047,0.016-4.552c0.05-24.293,0.111-54.524,32.547-73.484 c26.026-15.214,29.306-25.208,26.254-38.322c-3.586-15.404-17.653-19.396-28.63-18.141c-3.686,0.423-22.069,3.456-22.069,21.642 c0,11.213-9.092,20.306-20.307,20.306c-11.215,0-20.306-9.093-20.306-20.306c0-32.574,23.87-58.065,58.048-61.989 c35.2-4.038,65.125,16.226,72.816,49.282C297.824,181.361,256.555,205.485,241.018,214.566z"/> </g> </svg>
		</button>
		<hr>
		<div
			class="border border-15 bg p-2 text-success mt-2"
			style="
			float: inline-start;
			width: fit-content;
			display: flex;
			margin-left: 4px;
			align-content: flex-start;
			justify-content: center;
			align-items: center;

			"
			v-for="(f, i) in files"
			:key="i"
			:title="f.fileName"
		>
			<span
				class="pointer "
				@click="(e)=>{ rtr(f.fileUpload); }"
			>
				<i class="fa fa-download"></i>
			</span>
			&nbsp;
			&nbsp;
			&nbsp;
			<btn
				text="حذف"
				type="white text-danger"
				imgSize="30"
				textClass="p-0"
				@clickMe="rmv(i)"
			/>
		</div>
	</div>
</template>

	<script>
		import btn from  "../../UI/button/btn.vue";
		export default {
			name: 'previewImage',
			data(){
				return {
					inputCheck: true,
				}
			},
			components: {
				btn,
			},
			props: {
				label: {
					type: String,
					default: "label",
				},
				label_sm: {
					type: String,
					default: "",
				},
				label_class: {
					type: String,
					default: "",
				},
				value: {
					type: String,
					default: "",
				},
				accept: {
					type: String,
					default: "application/pdf, image/gif, image/jpeg, image/png",
				},
				textClass: {
					type: String,
					default: "",
				},
				files:{
					default: []
				},
				inputFile: {
					default: []
				},
				error: {
					default: true
				},
				error_text: {
					type: String,
					default: ""
				},
				leading: {
					type: String,
					default: "",
				},
			},
			mounted(){
				$(function () {
					$('[data-toggle="tooltip"]').tooltip()
				})
			},
			methods:{
				rmv(index){
					this.files.splice(index, 1);
					this.$emit('removeFile', this.files);
				},
				//____________________________________________________________________
				rtr(fileUpload){
					window.open(window.imgurl + fileUpload);
				},
				//______________________________________________________________________
				onFileChange(e, THIS = this){
					
					// const formData = new FormData();
					// formData.append("file", e.target.files[0]);

					// fetch('https://api.freeconvert.com/v1/process/import/upload', {
					// method: "POST",
					// body: formData,
					// headers: {
					// 	"Content-Type": "multipart/form-data",
					// 	'Authorization': `Bearer ${access_token}`,
					// }
					// })
					// .then(function (res) {
					// 	return res.json();
					// })
					// .then(function (body) {
					// });
					// this.$emit('chengeFile', e.target.files);
					// this.inputCheck = false;
					// setTimeout(()=>{
					// 	THIS.inputCheck = true;
					// }, 10);
				},
				uploadImages(e, THIS = this) {
					let image_id = Math.floor(Math.random() * (1000000 - 1000 + 1) + 1000);
					let name = "image_" + image_id;
					let imageData = null;
					let context = null;
					let maxWidth = 1024;
					let maxHeigt = 768;
					let width = maxWidth;
					let height = maxHeigt;
					var vm = this;
					let files = e.target.files;
					vm.imageIndex = 0;

					let formData = new FormData();
					for (let i = 0; i < files.length; i++) {
						let reader = new FileReader();
						let file = files[i];
						if (!file.type.match('image')) {
							this.$emit('chengeFile', e.target.files[0]);
							this.inputCheck = false;
							setTimeout(()=>{
								THIS.inputCheck = true;
							}, 10);
						};
						if (file) {
							var img = document.createElement("img");
							var canvas = $("<canvas/>").get(0);
							reader.onload = function (e) {
								img.src = e.target.result;

							};
							reader.readAsDataURL(file);
							img.onload = function () {
								// Draw
								context = canvas.getContext('2d');
								context.drawImage(img, 0, 0);
								if (img.width > maxWidth || img.height > maxHeigt) {
									width = maxWidth;
									height = maxHeigt;

									if (img.width > maxWidth) {
										width = maxWidth;
										var ration = maxWidth / img.width;
										height = Math.round(img.height * ration);
									}

									if (img.height > maxHeigt) {
										height = maxHeigt;
										var ration = maxHeigt / img.height;
										width = Math.round(img.width * ration);
									}
								} else {
									width = img.width;
									height = img.height;
								}
								canvas.width = width;
								canvas.height = height;

								context.drawImage(img, 0, 0, width, height);
								imageData = canvas.toDataURL('image/jpeg');
								imageData.replace('data:image/jpeg;base64,', '');

								let blobToFile = vm.dataURItoBlob(imageData);
								const cfile = new File(
									[blobToFile], name + ".jpg",
									{type: "image/jpeg", lastModified: Date.now()}
								);
								formData.append('ad_image', cfile);
								// upload to server with axios
								vm.$emit('chengeFile', cfile);
								vm.inputCheck = false;
								setTimeout(()=>{
									THIS.inputCheck = true;
								}, 10);
							}
						}
					}
				},
				dataURItoBlob(dataURI) {
					// convert base64 to raw binary data held in a string
					var byteString = atob(dataURI.split(',')[1]);
					// separate out the mime component
					var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
					// write the bytes of the string to an ArrayBuffer
					var arrayBuffer = new ArrayBuffer(byteString.length);
					var _ia = new Uint8Array(arrayBuffer);
					for (var i = 0; i < byteString.length; i++) {
						_ia[i] = byteString.charCodeAt(i);
					}
					var dataView = new DataView(arrayBuffer);
					var blob = new Blob([dataView], {type: mimeString});
					return blob;
				},

				//______________________________________________________________________
			}
		}
	</script>
<style>
	#customInput_file_cloude_span{
		transition: 0.3s;
	}
	#customInput_file_cloude_span:hover{
		color: #ff6839 !important;
}
</style>
